import { useEffect } from "react";
import styles from "./maintenanceCover.module.scss";

const UpdateBar = () => {
  useEffect(() => {
    setTimeout(() => {
      window.location.reload();
    }, 10000);
  }, []);

  return (
    <div className={styles.cover}>
      <h1 className="text-muted">
        Application is down for scheduled maintenance.
      </h1>
      <p className="text-muted">Come back later.</p>
    </div>
  );
};

export default UpdateBar;
